import { all, fork } from 'redux-saga/effects'

import UsersSaga from './UsersSaga'
import { queryService } from 'modules/module-api'
import API from 'api/clients'

export default function* usersSagas() {
  yield all([fork(new UsersSaga(API, queryService).supervise)])
}
